import React,{useEffect} from 'react';
import './sign-in-and-sign-up.styles.scss'
import SignIn from '../../components/sign-in/sign-in.component'
import SignUp from '../../components/sign-up/sign-up.component'
import {Helmet} from 'react-helmet'

const SingInAndSignUpPage = () =>  {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
    return(
    <div className="sign-in-and-sign-up">
        {/* <Helmet>
        <meta charset="utf-8"/>
        <meta name="viewport" content="width=device-width, initial-scale=1"/>
        <meta name="description" content="Welcome to Acceronix Join us now as we bring best quality tech gadgets and mobile accessories to you and revolutionize tech industry in Pakistan."/>
        <title>Join Tech Revolution Pakistan | Acceronix</title>
        </Helmet> */}
        <SignIn/>
        {/* <SignUp/> */}
    </div>
)};
export default SingInAndSignUpPage;